import React, { FC, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Markdown } from '@src/components/Markdown';
import { preventEvents } from '@src/util/preventEvents';
import { Props } from './props';
import './styles.scss';

const LINE_HEIGHT = 24;
const DEFAULT_LINE_LIMIT = 3;

export const TextWithReadMore: FC<Props> = ({
  text,
  lineLimit: providedLineLimit = DEFAULT_LINE_LIMIT,
  textClassName,
  buttonClassName,
}) => {
  const textEl = useRef<HTMLDivElement>(null);

  const [lineLimit, setSLineLimit] = useState<number>();

  const [shouldShowMore, setShouldShowMore] = useState<boolean>(true);

  const [isButtonShown, setIsButtonShown] = useState<boolean>(false);

  useEffect(() => {
    const element = textEl.current;
    const divHeight = element?.offsetHeight || 0;
    const lines = divHeight / LINE_HEIGHT;

    setIsButtonShown(lines > providedLineLimit);
    setSLineLimit(providedLineLimit);
  }, []);

  if (!text) {
    return null;
  }

  return (
    <div className="text-read-more">
      <div
        className={classnames('text-read-more__text', shouldShowMore && 'text-read-more__text--less')}
        ref={textEl}
        style={lineLimit ? { WebkitLineClamp: lineLimit } : undefined}
      >
        <Markdown markdown={text} style={{ lineHeight: `${LINE_HEIGHT / 10}rem` }} wrapperClassName={textClassName} />
      </div>

      {isButtonShown && (
        <span
          className={classnames('text-read-more__read-more', buttonClassName)}
          onClick={preventEvents(() => setShouldShowMore(!shouldShowMore))}
        >
          {shouldShowMore ? 'Read more' : 'Show less'}
        </span>
      )}
    </div>
  );
};
